import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { tokenStore } from '@/lib/api';

/**
 * Catches anything a route throws while rendering. Without it React Router
 * shows a raw stack trace on a white page, which tells the user nothing and
 * leaves them stuck.
 */
export function ErrorPage() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4">
      <div className="w-full max-w-md rounded-lg border bg-card p-6 text-center shadow-sm">
        <AlertTriangle className="mx-auto mb-4 h-10 w-10 text-amber-500" />
        <h1 className="text-lg font-semibold">This page could not be displayed</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The error has been logged. Reloading usually clears it.
        </p>

        <pre className="scrollbar-thin mt-4 max-h-32 overflow-auto rounded-md bg-muted p-3 text-start text-xs text-muted-foreground">
          {message}
        </pre>

        <div className="mt-5 flex justify-center gap-2">
          <Button onClick={() => window.location.reload()}>Reload</Button>
          <Button
            variant="outline"
            onClick={() => {
              // A stale or malformed cached session is the usual cause, so
              // offer a clean sign-in rather than leaving the user stuck.
              tokenStore.clear();
              window.location.href = '/login';
            }}
          >
            Sign in again
          </Button>
        </div>
      </div>
    </div>
  );
}
